import React, { useState } from "react";
import { useFormik } from "formik";
import { Input, Row, Col, Image, Typography } from "antd";
import { LoginOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ENVIRONMENT } from "../../utils/properties";
import { useDispatch, useSelector } from "react-redux";
import PFButton from "../../components/functional_components/Button/PFButton";
import { setUserInfo, setUsername } from "../../redux/ducks/UserInfo";
// style
import "./login.css";
// images
import pfIcon from "../../assets/images/pininfarina-logo-icon.png";
import pfLogo from "../../assets/images/pininfarina-logo-text.png";
import { useTranslation } from "react-i18next";
import { setUserMaster } from "../../redux/ducks/UserInfo";
import Authentication from "../../services/api/Authentication";
import { setLanguage } from "../../redux/ducks/Language";
import { showError } from "../../utils/utilities";
import { get } from "lodash";

const { Link } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", {}));
  const formikLogin = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    onSubmit: (values) => {
      sendLogin(values);
    },
  });
  const [isLoading, setIsLoading] = useState(false);

  const sendLogin = async (values) => {
    setIsLoading(true);
    const userInfo = await Authentication.login(values);
    // const userInfo = {"data":{"name":"Beije Consulting","username":"beije","token":"eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJiZWlqZSIsInJvbGUiOiJST0xFX1NZU1RFTV9JVCIsImNyZWF0ZWQiOjE2MzUzMjc5NDQwMDksImV4cCI6MTYzNTMzMzM0NH0.YGqJjngEe8i7sJ03EW_ZBPZPVEzs__m31YKbwXFkLjpyKCAGUWIcxGDP7eUam1xCDrEpTQ83xzvvVMSH_O1Isw","userType":"INTERNAL","roles":["PM", "SUPER_PM","RESP_CDC"],"info":{"alertPmApprovalProposal":false,"alertDmOrdersProjectTask":true}}};
    if (!userInfo.error && userInfo.data) {
      dispatch(setUserInfo(userInfo.data));
      if (currentLanguage === null) {
        dispatch(setLanguage("GB")); // set default language
      }
      if (userInfo.data.userType === "MASTER") {
        dispatch(setUserMaster(userInfo.data));
        setIsLoading(false);
        navigate("/choose-user");
      } else {
        setIsLoading(false);
        navigate("/");
      }
    } else {
      if (userInfo.error && userInfo.error.messageCode === "ER016") {
        dispatch(setUsername(values.username));
        setIsLoading(false);
        navigate("/reset-password");
      }
      setIsLoading(false);
      showError(get(userInfo, "error.messageCode", "ER000"));
    }
  };

  return (
    <Row className="login_container" type="flex" justify="center" align="middle">
      <Col className="login_form_container">
        <div className="login_form_container_rows">
          <div>
            <Row type="flex" justify="center" align="middle">
              <Image src={pfIcon} width={80} preview={false} />
            </Row>
            <Row type="flex" justify="center" align="middle">
              <Image src={pfLogo} width={255} preview={false} />
            </Row>
          </div>
          <div>
            <Row className="login_form_input_margin">
              <label htmlFor="username">{t("general.Username")}</label>
              <Input
                id="username"
                name="username"
                placeholder={t("general.Username")}
                onChange={formikLogin.handleChange}
                onBlur={formikLogin.handleBlur}
                value={formikLogin.values.username}
              />
            </Row>
            <Row className="login_form_input_margin">
              <label htmlFor="password">{t("general.Password")}</label>
              <Input.Password
                id="password"
                name="password"
                placeholder={t("general.Password")}
                onChange={formikLogin.handleChange}
                onBlur={formikLogin.handleBlur}
                value={formikLogin.values.password}
                className="input-password-login"
              />
            </Row>
            <Row type="flex" justify="end" align="middle">
              <Link href={`${ENVIRONMENT.BASE_URL}recovery-password`} className="link-forgot-password">
                {t("general.forgotPassword")}
              </Link>
            </Row>
          </div>
          <Row type="flex" justify="center" align="middle">
            <PFButton
              type="primary"
              currentIcon={<LoginOutlined className="icon-medium" />}
              isLoading={isLoading}
              clickCallback={formikLogin.submitForm}
              currentSize="large"
            />
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default Login;
